var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-start"},[_c('div',{attrs:{"id":"back"}},[_c('router-link',{attrs:{"to":"/work"}},[_c('i',{staticClass:"times"})])],1),_c('div',{staticClass:"container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }